/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class PinterestImageUrl extends React.Component {
    render () {
        let urlValue = (this.props.post.pinterestUrl !== '') ? this.props.post.pinterestUrl : this.props.post.item.longUrl;
        return (
            <div className="post-modal-pinterest-url">
                <div className="pinterest-header">
                    <i className="fa fa-pinterest"/>Add a URL for Pinterest
                </div>
                <div className="pinterest-field">
                    <input type="text" className="text-input large" value={urlValue} onChange={this.props.onInputChange} data-field={"posts[" + this.props.activePost + "].pinterestUrl"}/>
                </div>
            </div>
        );
    }
}

PinterestImageUrl.displayName = "PinterestImageUrl";


export default PinterestImageUrl;
